import React from "react";
import emoji from "react-easy-emoji";
import Typewriter from "typewriter-effect";
const Type = () => {
  return (
    <Typewriter
      options={{
        strings: [
          `Learner first`,
          "Front End Developer",
          "Learning MERN stack",
          "Interest in ROBOTICS",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
};

export default Type;
